import { pilot } from '~/services/serviceInstances';

interface Response {
  enabled: boolean;
}

export const getWellKnownFieldsStatus = async (): Promise<boolean> => {
  const response: Response = await pilot.get('client/well-known-fields/');
  return response.enabled;
};
